<template>
<div class="container-main">
    
    <b-modal centered no-close-on-backdrop size="lg" ok-title="Xác nhận" hide-footer hide-header button-size="sm" id="supportModal">
        <div class="modal-border d-flex p-4 align-items-center justify-content-center">
            <button @click="hideModal('supportModal')" class="x-button border-0 bg-transparent">
                <img src="../../assets/xmas/xbutton.png" alt="">
            </button>
            <div class="message-block text-center">
                <img class="mw-100 px-2" src="../../assets/xmas/support.png" alt=""/>
            </div>
        </div>
    </b-modal>

    <header class="mt-3">
        <div class="container d-flex justify-content-center align-items-center position-relative ">
            <div id="logo" class="d-flex">
                <div class="logo-image text-center position-relative align-items-center me-4 me-md-0">
                    <img class=" mw-100" src="../../assets/newyear/logo.png" alt="">
                </div>
            </div>
            <button v-b-modal.supportModal class=" border-0 bg-transparent position-md-absolute position-relative" style="right:0px">
                <img class="mw-100" src="../../assets/newyear/hotro.png" alt="">
            </button>
        </div>
        
        <div class="container my-4 pt-3">
            <div class="text-center">
                <img src="../../assets/newyear/sudungnangluc-headline.png" class="mw-100" alt=""/>
            </div>
            <div class="text-center d-none d-sm-block">
                <img src="../../assets/newyear/speakwell-desc.png" class="mw-100" alt=""/>
            </div>
            <div class="text-center d-sm-none d-block">
                <img src="../../assets/newyear/speakwell-desc-mb.png" class="mw-100" alt=""/>
            </div>
        </div>
    </header>

    <div class="process-fixed" :class="{'show': processShow}">
        <div class="process-body container">
            <div class="section-name">
                <p class="w-100 m-0">{{ sectionName }}</p>
            </div>
            <div class="process-count">
                <span style="width: 160px;">Tiến trình</span>
                <div class="process">
                    <div :style="{'width': `${processWidth}px`}" class="process-current"></div>
                </div>
                <span>{{ questionProcess.questionCurrent }}/{{ questionProcess.questionCount }}</span>
            </div>
        </div>
    </div>
	<div class="content-main container">
        
		<div class="question-main text-center mb-5">
			<div v-if="page == 5" class="thankyou-top">
                <img class="header-bg" src="../../assets/thank-popup-header.png" alt="">
                <img class="congraturation" src="../../assets/congraturation.png" alt="">
                <img src="../../assets/icon-book.png" class="thankyou-book-icon" alt="">
                <img src="../../assets/icon-paper.png" class="thankyou-paper-icon" alt="">
                <img src="../../assets/popup-chacter-2.png" class="thankyou-chacter-icon" alt="">
            </div>
			<div class="card-main" :class="{'type2': page == 5}">
				<div class="card-content">
					<div class="card-container">
                        <component :is="pageComponent" />
						<!-- <router-view @changeRouteTitle="changeRouteTitle" /> -->
					</div>
				</div>
			</div>
		</div>
	</div>

    <input type="text" class="" id="inputfocus">
</div>
    <!-- <div>
        <b-modal id="testing-alert" centered no-close-on-backdrop no-close-on-esc title="Thông báo" @ok="testContinueOk" @cancel="testContinueCancel" ok-title="Dạ có!" cancel-title="Không ạ!" hide-header-close>
            <p class="my-4">Bé vẫn chưa làm xong bài thi, bé có muốn làm tiếp hay không?</p>
        </b-modal>
        <component :is="pageComponent" />
    </div> -->
</template>


<script>

import Vue from 'vue'
import camelCase from 'lodash/camelCase'
import upperFirst from 'lodash/upperFirst'

export default {
    data: function () {
        return {
            processWidth: 0
        }
    },
    created() {
        this.loadComponent()
	},

    computed: {
        processShow () {
            return this.$store.state.page == 3 ? 1 : 0
        },
        questionProcess () {
            return this.$store.state.questionProcess;
        },
        sectionName () {
            return this.$store.state.sectionName
        },
        examId () {
            return this.$store.state.examId
        },
        pageComponent() {
            return `page${this.page}`
        },
        page () {
            return this.$store.state.page
        }
    },

    methods: {
        changeRouteTitle (title) {
            this.routeTitle = title
        },
        testContinueOk () {
            if (this.testHistoryData.test_result ) {
                this.$store.commit('SET_TEST_HISTORY', this.testHistoryData)
            }
            this.$store.commit('SET_PAGE', 3)

        },
        testContinueCancel () {
            const testHistoryId = localStorage.getItem(`_speakup_exam${this.examId}`)

            this.$http.post('/test-done', {
                id: testHistoryId,
            }).then(res => {
                if (res.data.code == 1) {
                    location.reload()
                }
            })
        },
        loadComponent() {
            const requireComponent = require.context('./', false, /\.vue$/i);
            requireComponent.keys().forEach(fileName => {

                const componentConfig = requireComponent(fileName)
                const componentName = upperFirst(
                    camelCase(
                        fileName.split('/')
                        .pop()
                        .replace(/\.\w+$/, '')
                    )
                )
                
                Vue.component(
                    componentName,
                    componentConfig.default || componentConfig
                )
            })
        }
    },
    watch: {
        'questionProcess': {
            handler () {
                if (document.querySelector('.process-count .process')) {
                    const elementWidth = this.getClientWidth()
                    this.processWidth = (elementWidth/ this.questionProcess.questionCount) * this.questionProcess.questionCurrent
                }
            },
            deep: true
        },
        examId (value) {
            console.log('examID: ', value)
            if (value) {
                // check test history
                const testHistoryId = localStorage.getItem(`_speakup_exam${value}`)
                if (testHistoryId) {
                    // 
                    this.$http.get('/get-test-history', {
                        params: {
                            id: testHistoryId,
                        }
                    }).then(res => {
                        if (res.data.code == 1) {
                            this.testHistoryData = res.data.data
                            if (this.testHistoryData.status == 0) {
                                this.$bvModal.show('testing-alert')
                            }
                        }
                    })
                }
            }
        },
    },


}

</script>


<style>



@media (min-width: 992px) {

    .position-md-absolute {
        position: absolute !important;
    }
}

.led-right {
    right: -160%;
    top: 0;
}
.led-left {
    left: -160%;
    top: 0;
}

html {
    overflow-x: hidden;
}

.section-name {
    display: block;
    margin-left: 10px;
    margin-right: 10px;
    font-family: 'iCiel Crocante';
    color: #f57b32;
    font-size: 1.5rem;
}

.section-name, .process-count {
    width: 50%;
    justify-content: end;
    align-items: center;
    display: flex;
}

.process-count .process {
    /* width: 310px; */
    /* min-width: 100px; */
    background-color: #af275a;
    height: 18px;
    border-radius: 24px;
    border: 2px solid #af275a;
    -webkit-align-items: center;
    -moz-box-align: center;
    align-items: center;
    -webkit-flex-grow: 1;
    -moz-box-flex: 1;
    flex-grow: 1;
    margin-right: 16px;
    cursor: pointer;
    display: flex;
}

.process-count span {
    display: block;
    margin-left: 10px;
    margin-right: 10px;
    font-family: 'iCiel Crocante';
    color: #f57b32;
    font-size: 1.5rem;
}

.process-count span:last-child {
    color: #af275a;
}

.process-current {
    background: linear-gradient(0deg, rgba(246,160,13,1) 0%, rgba(243,255,1,1) 50%, rgba(246,160,13,1) 100%);
    height: 14px;
    border-radius: 24px;
}

.process-fixed .process-body {
    padding: 7px;
    display: flex;
}


.process-fixed.show {
    display: block;
}

.process-fixed {
    display: none;
    position: fixed;
    bottom: 0;
    left: 0;
    width: 100%;
    z-index: 99999999;
    background-color: #fff;
    box-shadow: 0px 0px 10px 0px #00000030;
}

@media (max-width: 768px) {
   
    .process-fixed .process-body {
        display: block;
    }

    .process-fixed .process-body .process-count {
        width: 100%;
    }

    .section-name, .process-count span {
        font-size: 1.3rem;
    }

}


.panel-tutorial ul {
    list-style: none !important;
    padding: 0px;
}

.panel-tutorial ul li span {
    color: #0d5fcb;
    font-family: 'iCiel Crocante';
    padding-right: 10px;
}

@media (max-width: 576px) {
    .panel-tutorial {
        padding: 20px !important;
        margin-top: 20px !important;
        margin-bottom: 20px !important;
    }

    .panel-tutorial ul li {
        padding: 0px;
    }

}


#supportModal .modal-border {
    position: relative;
}

#supportModal .x-button {
    position: absolute;
    right: -40px;
    top: -40px;
}

#supportModal .x-button img {
    width: 70px;
}

#supportModal .modal-body {
    padding: 0;
}

#supportModal .modal-content {
    border: 16px solid #185e30;
    border-radius: 20px;
    box-shadow: 6px 7px 1px #000000;
    background-color: #fff;
}

#supportModal .chacter {
    max-width: 22%;
    height: 100%;
    margin: auto 20px 10px 30px;
}

#supportModal .message-block p {
    font-family: 'iCiel Crocante';
    font-size: 1.5rem;
    color: #ff5c00;
}

#supportModal .message-block p span {
    color: #0781ff;
}

</style>

<style>

.footer {
    margin-top: -190px;
}

.info-submit button img {
    width: 80%;
}

header {
	position: relative;
    width: 100%;
	z-index: 999;
}

.content-main {
	top: 0;
    z-index: 999;
    position: relative;
}

.container-main {
	background-image: url(../../assets/newyear/bg.jpg);
    background-size: cover;
    background-attachment: fixed;
    background-repeat: no-repeat;

	overflow: hidden;
    background-position: center center;
}

.main-bg-top {
    position: absolute;
    left: 0;
    top: 0;
}

.main-bg-bottom {
    position: absolute;
    left: 0;
    bottom: 0;
}

.ray-light-behide {
    position: absolute;
    top: 0;
    left: 0;
    z-index: 0;
}


.card-container {
    padding-left: 70px;
    padding-right: 70px;
}

@media (max-width: 1200px) {
    .card-container {
        padding-left: 10px;
        padding-right: 10px;
    }
}

@media (max-width: 768px) {
    .question-main {
        margin-top: 0px;
    }

    header, .process-fixed {
        position: inherit !important;
    }
}

@media (max-width: 576px) {
    .card-main {
        border: none;
        margin-bottom: 20px;
    }

}


.thankyou-top {
    text-align: center;
    margin-top: 90px;
    position: relative;
}

.congraturation {
    position: absolute;
    bottom: 30%;
    left: 50%;
    transform: translateX(-57%);
    max-width: 50%;
}

.thankyou-top .header-bg {
    max-width: 80%;
}

.thankyou-book-icon {
    position: absolute;
    left: 0;
    z-index: 1;
    max-width: 20%;
}

.thankyou-paper-icon {
    position: absolute;
    right: 0;
    bottom: 0;
    z-index: 1;
    max-width: 15%;
}

.thankyou-chacter-icon {
    position: absolute;
    right: 12%;
    max-width: 15%;
    bottom: 18px;
    z-index: 1;
}

#inputfocus {
    height: 0;
    font-size: 0;
    padding: 0;
    margin: 0;
    border: none;
}</style>